"use client";
import { DefaultVideoSkin } from "../../internal/skins/default-video/skin.js";
import { jsx } from "react/jsx-runtime";
//#region src/presets/video/skin.tsx
function VideoSkin(props) {
	return /* @__PURE__ */ jsx(DefaultVideoSkin, { ...props });
}
//#endregion
export { VideoSkin };

//# sourceMappingURL=skin.js.map